module.exports = __webpack_public_path__ + "static/csa-logo-fr-69d08eb6c479bf30405ae6f6d854c1a7.jpg";